import * as RadixSelect from '@radix-ui/react-select'
import { FC, forwardRef, useContext } from 'react'
import { Icons } from '../../../index'
import { SelectContext } from '../SelectContext'
import { TriggerPrimitive } from '../primitives'

export interface Props extends RadixSelect.SelectTriggerProps {
  placeholder?: string
  width?: 'full'
  displayValue?: string
}

export const Trigger: FC<Props> = forwardRef<HTMLButtonElement, Props>(
  ({ placeholder, displayValue, ...props }, ref) => {
    const { variant, value } = useContext(SelectContext)

    return (
      <TriggerPrimitive {...props} variant={variant} ref={ref}>
        <RadixSelect.Value placeholder={placeholder}>{displayValue || value}</RadixSelect.Value>
        <Icons.ChevronDown />
      </TriggerPrimitive>
    )
  }
)
